import * as Types from './types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type HasFailedPaymentQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HasFailedPaymentQuery = { __typename?: 'Query', hasFailedPayment: boolean };


export const HasFailedPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasFailedPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasFailedPayment"}}]}}]} as unknown as DocumentNode<HasFailedPaymentQuery, HasFailedPaymentQueryVariables>;